module.exports = __webpack_public_path__ + "img/tarifstudio.94767cba.jpg";